export const profileRoutes = {
  profile: {
    path: '/profile',
  },
  settings: {
    path: '/profile/settings',
  },
  password: {
    path: '/profile/password',
  },
  // The US account surface owns these; Canada keeps the `shipping` routes below.
  address: {
    path: '/profile/address',
  },
  newAddress: {
    path: '/profile/address/new',
  },
  updateAddress: {
    path: '/profile/address/:id',
    build({ id }: { id: string }) {
      return this.path.replace(':id', id);
    },
  },
  shipping: {
    path: '/profile/shipping',
  },
  newShipping: {
    path: '/profile/shipping/new',
  },
  updateShipping: {
    path: '/profile/shipping/:id',
    build({ id }: { id: string }) {
      return this.path.replace(':id', id);
    },
  },
  // Canada's card-upload insurance flow. US patients never see this route
  // (see `usInsurance` below for the separate US read-only surface).
  insurance: {
    path: '/profile/insurance',
  },
  insuranceType: {
    path: '/profile/insurance-type',
  },
  // The US account surface owns this. It can't reuse `insurance` above
  // because that path is already Canada's card-upload flow.
  usInsurance: {
    path: '/profile/us-insurance',
  },
  newInsurance: {
    path: '/profile/insurance/new',
  },
  updateInsurance: {
    path: '/profile/insurance/:id',
    build({ id }: { id: string }) {
      return this.path.replace(':id', id);
    },
  },
  updateIdentification: {
    path: '/profile/identification/update',
  },
  verifyIdentification: {
    path: '/profile/identification/update/verify',
  },
  successfulIdentification: {
    path: '/profile/identification/successful',
  },
  payments: {
    path: '/profile/payments',
  },
  newPaymentMethod: {
    path: '/profile/payments/new',
  },
} as const;
